import React from 'react';
import { Form, Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { InputField } from 'Common/SemanticWrapper';
import { AdjustmentEnum } from 'Common/FieldEnum';

import { AdjustmentInfo } from '../../containers/createEditAdjustment/AdjustmentInfo';

const PreviewAdjustmentComponent = props => {
  const {
    adjustmentItemsInfo,
    onResetPageOnDataChange,
    resetPageOnDataChange,
  } = props;

  return (
    <Form>
      <Grid>
        <Grid.Row>
          <Grid.Column width={3}>
            <Field
              name={AdjustmentEnum.Comments}
              component={InputField}
              type="text"
              maxLength={50}
              label={'Comments'}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={4}>
            <label className={'text-orange'}>Adjustment Items</label>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <hr />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Field
              component={AdjustmentInfo}
              name={AdjustmentEnum.AdjustmentItemsInfo}
              {...{
                dataSource: adjustmentItemsInfo,
                isPreviewPage: true,
                onResetPageOnDataChange: onResetPageOnDataChange,
                resetPageOnDataChange: resetPageOnDataChange,
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

PreviewAdjustmentComponent.propTypes = {
  adjustmentItemsInfo: PropTypes.array,
  onResetPageOnDataChange: PropTypes.func,
  resetPageOnDataChange: PropTypes.bool,
};

PreviewAdjustmentComponent.defaultProps = {
  adjustmentItemsInfo: [],
  onResetPageOnDataChange: () => {},
  resetPageOnDataChange: true,
};
export default PreviewAdjustmentComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/adjustment/components/createEditAdjustment/PreviewAdjustmentComponent.js